import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const OndcReportUpload = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.ONDC_UPLOAD_FAILURE:
      return { ...state, ondcReportUploadSheetError: action.value };
    case actions.ONDC_UPLOAD:
      return { ...state, ondcReportUploadSheet: action.value };
    default:
      return state;
  }
};

export default OndcReportUpload;

